/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_ApprovedInputs */



/**
* | output |
* | --- |
* | "Approved" |
*
* @param {Metadata_Merge_ApprovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_approved = /** @type {((inputs?: Metadata_Merge_ApprovedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_ApprovedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approuvé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmigt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approvato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Утверждено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已批准")
	if (locale === "ja") return /** @type {LocalizedString} */ ("承認済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वीकृत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprovado")
	return /** @type {LocalizedString} */ ("Approved")
});